import MicroModal from 'micromodal'
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["page", "contentBody", "prevButton", "nextButton", "continue"];
  static values = {
    count: {type: Number, default: 0}
  }

  connect() {
    if(!document.getElementById("side_nav")){
      this.continueTarget.style.display = "none";
      if(this.pageTarget.innerText == "1"){
          this.prevButtonTarget.style.display = "none";
      }
    }
  }

  next() {

    this.pageTarget.innerText = parseInt(this.pageTarget.innerText) + 1;
    if(this.pageTarget.innerText == parseInt(this.countValue).toString()){
        this.continueTarget.style.display = "block";
        this.nextButtonTarget.style.display = "none";
    }
    this.contentBodyTarget.style.marginLeft = (parseInt(this.pageTarget.innerText) - 1) * (-36) + "rem";
    
    if(this.pageTarget.innerText != 1){
        this.prevButtonTarget.style.display = "block";
    }
  }

  prev() {
    if(this.pageTarget.innerText == "8"){
        this.nextButtonTarget.style.display = "block";
        this.continueTarget.style.display = "none";
    }
    this.pageTarget.innerText = parseInt(this.pageTarget.innerText) - 1;
    if(this.pageTarget.innerText == "1"){
        this.prevButtonTarget.style.display = "none";
    }
    
    this.contentBodyTarget.style.marginLeft = (parseInt(this.pageTarget.innerText) - 1) * (-36) + "rem";

  }

  close() {
    this.pageTarget.innerText = 1;
    this.prevButtonTarget.style.display = "none";
    this.nextButtonTarget.style.display = "block";
    this.continueTarget.style.display = "none";
    this.contentBodyTarget.style.marginLeft = "0";
    document.getElementById("intro-container").style.display = "none";
  }
  open() {
    document.getElementById("intro-container").style.display = "block";
  }
}
